export default __webpack_public_path__ + "static/media/1242.41ecb490.png";